import React from 'react';
import UserIcon from '@tradera/tradera-ui/icons/user.svg?jsx';

const Profile = ({ isLoggedIn, facebookId }) =>
    isLoggedIn && facebookId ? (
        <img
            width="24"
            height="24"
            src={`https://graph.facebook.com/v2.11/${facebookId}/picture?type=square&height=48&width=48`}
            style={{
                borderRadius: '4px',
                margin: '-2px 4px -2px -2px'
            }}
        />
    ) : (
        <div>
            <UserIcon className="icon icon-dark d-none d-md-block" />
            <UserIcon className="icon icon-dark icon-md d-md-none d-block" />
        </div>
    );

export default Profile;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/profile.jsx